import { ComponentProps, useMemo } from 'react';

import { Head } from '@wetransfer/transfer-new/components/Head/Head';
import { MetadataResponse } from '@wetransfer/transfer/api/metadata';

interface useTransferOpenGraphsProps {
  metadata: MetadataResponse | null;
  securityHash?: string;
}

const useTransferOpenGraph = ({
  metadata,
  securityHash,
}: useTransferOpenGraphsProps): ComponentProps<typeof Head>['openGraph'] => {
  const openGraph = useMemo<ComponentProps<typeof Head>['openGraph']>(() => {
    if (metadata !== null) {
      return {
        title: metadata.title ? metadata.title : undefined,
        description:
          metadata.files_count === 1
            ? `${metadata?.files_count} file sent via WeTransfer, the simplest way to send your files around the world`
            : `${metadata?.files_count} files sent via WeTransfer, the simplest way to send your files around the world`,

        image:
          securityHash !== undefined
            ? `/unfurl/${metadata.id}/${securityHash}`
            : undefined,
      };
    }
  }, [securityHash, metadata]);

  return openGraph;
};

export default useTransferOpenGraph;
